import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/shared/components/atoms/ui/tabs'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/shared/components/atoms/ui/card'
import { ContractTypesTable } from '../components/ContractTypesTable'
import { GeoLocationsTable } from '../components/GeoLocationsTable'
import { DepartmentsTree } from '../components/DepartmentsTree'
import { EnvironmentsTable } from '../components/EnvironmentsTable'
import { CloudProvidersTable } from '../components/CloudProvidersTable'
import { LeadershipTypesTable } from '../components/LeadershipTypesTable'
import { PersonTypesTable } from '../components/PersonTypesTable'

export function MasterDataPage() {
	return (
		<div>
			<h1 className="text-2xl font-bold text-foreground mb-2">Master Data</h1>
			<p className="text-muted-foreground mb-6">Manage reference data used across the organization</p>

			<Tabs defaultValue="contract-types" className="w-full">
				<TabsList className="grid w-full grid-cols-7">
					<TabsTrigger value="contract-types">Contract Types</TabsTrigger>
					<TabsTrigger value="geo-locations">Geo Locations</TabsTrigger>
					<TabsTrigger value="departments">Departments</TabsTrigger>
					<TabsTrigger value="environments">Environments</TabsTrigger>
					<TabsTrigger value="cloud-providers">Cloud Providers</TabsTrigger>
					<TabsTrigger value="leadership-types">Leadership Types</TabsTrigger>
					<TabsTrigger value="person-types">Person Types</TabsTrigger>
				</TabsList>

				<TabsContent value="contract-types" className="mt-6">
					<Card>
						<CardHeader>
							<CardTitle>Contract Types</CardTitle>
							<CardDescription>Manage contract type classifications</CardDescription>
						</CardHeader>
						<CardContent>
							<ContractTypesTable />
						</CardContent>
					</Card>
				</TabsContent>

				<TabsContent value="geo-locations" className="mt-6">
					<Card>
						<CardHeader>
							<CardTitle>Geographic Locations</CardTitle>
							<CardDescription>Manage office locations and country codes</CardDescription>
						</CardHeader>
						<CardContent>
							<GeoLocationsTable />
						</CardContent>
					</Card>
				</TabsContent>

				<TabsContent value="departments" className="mt-6">
					<Card>
						<CardHeader>
							<CardTitle>Departments</CardTitle>
							<CardDescription>Manage organizational structure and hierarchy</CardDescription>
						</CardHeader>
						<CardContent>
							<DepartmentsTree />
						</CardContent>
					</Card>
				</TabsContent>

				<TabsContent value="environments" className="mt-6">
					<Card>
						<CardHeader>
							<CardTitle>Environments</CardTitle>
							<CardDescription>Manage deployment environments</CardDescription>
						</CardHeader>
						<CardContent>
							<EnvironmentsTable />
						</CardContent>
					</Card>
				</TabsContent>

				<TabsContent value="cloud-providers" className="mt-6">
					<Card>
						<CardHeader>
							<CardTitle>Cloud Providers</CardTitle>
							<CardDescription>Manage cloud service providers</CardDescription>
						</CardHeader>
						<CardContent>
							<CloudProvidersTable />
						</CardContent>
					</Card>
				</TabsContent>
				<TabsContent value="leadership-types" className="mt-6">
					<Card>
						<CardHeader>
							<CardTitle>Leadership Types</CardTitle>
							<CardDescription>Manage leadership type classifications</CardDescription>
						</CardHeader>
						<CardContent>
							<LeadershipTypesTable />
						</CardContent>
					</Card>
				</TabsContent>
				<TabsContent value="person-types" className="mt-6">
					<Card>
						<CardHeader>
							<CardTitle>Person Types</CardTitle>
							<CardDescription>Manage person type classifications (employee categories)</CardDescription>
						</CardHeader>
						<CardContent>
							<PersonTypesTable />
						</CardContent>
					</Card>
				</TabsContent>
			</Tabs>
		</div>
	)
}
